export default __webpack_public_path__ + "static/media/ff_on_white.d21a7b0c.svg";